import { ElementRef, Renderer2, Input, Component, ChangeDetectionStrategy, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomHandler } from 'primeng/dom';
import { RouterModule } from '@angular/router';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@angular/router';

const _c0 = function (a0) { return { "ui-helper-hidden": a0 }; };
function MegaMenu_ng_template_2_li_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "li", 6);
} if (rf & 2) {
    const category_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(1, _c0, category_r2.visible === false));
} }
function MegaMenu_ng_template_2_li_1_a_2_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 16);
} if (rf & 2) {
    const category_r2 = ɵngcc0.ɵɵnextContext(3).$implicit;
    ɵngcc0.ɵɵproperty("ngClass", category_r2.icon);
} }
const _c1 = function (a0, a1) { return { "pi-caret-down": a0, "pi-caret-right": a1 }; };
function MegaMenu_ng_template_2_li_1_a_2_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 17);
} if (rf & 2) {
    const ctx_r11 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(1, _c1, ctx_r11.orientation == "horizontal", ctx_r11.orientation == "vertical"));
} }
const _c2 = function (a1) { return { "ui-menuitem-link ui-corner-all": true, "ui-state-disabled": a1 }; };
function MegaMenu_ng_template_2_li_1_a_2_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 12);
    ɵngcc0.ɵɵlistener("click", function MegaMenu_ng_template_2_li_1_a_2_Template_a_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r14); const category_r2 = ɵngcc0.ɵɵnextContext(2).$implicit; const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13.itemClick($event, category_r2); });
    ɵngcc0.ɵɵtemplate(1, MegaMenu_ng_template_2_li_1_a_2_span_1_Template, 1, 1, "span", 13);
    ɵngcc0.ɵɵelementStart(2, "span", 14);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, MegaMenu_ng_template_2_li_1_a_2_span_4_Template, 1, 4, "span", 15);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const category_r2 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵclassMap(category_r2.styleClass);
    ɵngcc0.ɵɵproperty("href", category_r2.url || "#", ɵngcc0.ɵɵsanitizeUrl)("ngClass", ɵngcc0.ɵɵpureFunction1(12, _c2, category_r2.disabled))("ngStyle", category_r2.style);
    ɵngcc0.ɵɵattribute("target", category_r2.target)("title", category_r2.title)("id", category_r2.id)("tabindex", category_r2.tabindex ? category_r2.tabindex : "0");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", category_r2.icon);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(category_r2.label);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", category_r2.items);
} }
function MegaMenu_ng_template_2_li_1_a_3_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 16);
} if (rf & 2) {
    const category_r2 = ɵngcc0.ɵɵnextContext(3).$implicit;
    ɵngcc0.ɵɵproperty("ngClass", category_r2.icon);
} }
const _c3 = function () { return { exact: false }; };
function MegaMenu_ng_template_2_li_1_a_3_Template(rf, ctx) { if (rf & 1) {
    const _r20 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 18);
    ɵngcc0.ɵɵlistener("click", function MegaMenu_ng_template_2_li_1_a_3_Template_a_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r20); const category_r2 = ɵngcc0.ɵɵnextContext(2).$implicit; const ctx_r19 = ɵngcc0.ɵɵnextContext(); return ctx_r19.itemClick($event, category_r2); });
    ɵngcc0.ɵɵtemplate(1, MegaMenu_ng_template_2_li_1_a_3_span_1_Template, 1, 1, "span", 13);
    ɵngcc0.ɵɵelementStart(2, "span", 14);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const category_r2 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵclassMap(category_r2.styleClass);
    ɵngcc0.ɵɵproperty("routerLink", category_r2.routerLink)("queryParams", category_r2.queryParams)("routerLinkActive", "ui-menuitem-link-active")("routerLinkActiveOptions", category_r2.routerLinkActiveOptions || ɵngcc0.ɵɵpureFunction0(20, _c3))("ngClass", ɵngcc0.ɵɵpureFunction1(21, _c2, category_r2.disabled))("ngStyle", category_r2.style)("fragment", category_r2.fragment)("queryParamsHandling", category_r2.queryParamsHandling)("preserveFragment", category_r2.preserveFragment)("skipLocationChange", category_r2.skipLocationChange)("replaceUrl", category_r2.replaceUrl)("state", category_r2.state);
    ɵngcc0.ɵɵattribute("tabindex", category_r2.tabindex ? category_r2.tabindex : "0")("target", category_r2.target)("title", category_r2.title)("id", category_r2.id);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", category_r2.icon);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(category_r2.label);
} }
function MegaMenu_ng_template_2_li_1_div_4_ng_template_2_ng_template_1_ng_template_3_li_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "li", 25);
} if (rf & 2) {
    const item_r28 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(1, _c0, item_r28.visible === false));
} }
function MegaMenu_ng_template_2_li_1_div_4_ng_template_2_ng_template_1_ng_template_3_li_1_a_1_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 16);
} if (rf & 2) {
    const item_r28 = ɵngcc0.ɵɵnextContext(3).$implicit;
    ɵngcc0.ɵɵproperty("ngClass", item_r28.icon);
} }
const _c4 = function (a0) { return { "ui-state-disabled": a0 }; };
function MegaMenu_ng_template_2_li_1_div_4_ng_template_2_ng_template_1_ng_template_3_li_1_a_1_Template(rf, ctx) { if (rf & 1) {
    const _r37 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 29);
    ɵngcc0.ɵɵlistener("click", function MegaMenu_ng_template_2_li_1_div_4_ng_template_2_ng_template_1_ng_template_3_li_1_a_1_Template_a_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r37); const item_r28 = ɵngcc0.ɵɵnextContext(2).$implicit; const ctx_r36 = ɵngcc0.ɵɵnextContext(6); return ctx_r36.itemClick($event, item_r28); });
    ɵngcc0.ɵɵtemplate(1, MegaMenu_ng_template_2_li_1_div_4_ng_template_2_ng_template_1_ng_template_3_li_1_a_1_span_1_Template, 1, 1, "span", 13);
    ɵngcc0.ɵɵelementStart(2, "span", 14);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r28 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵproperty("href", item_r28.url || "#", ɵngcc0.ɵɵsanitizeUrl)("ngClass", ɵngcc0.ɵɵpureFunction1(8, _c4, item_r28.disabled));
    ɵngcc0.ɵɵattribute("target", item_r28.target)("title", item_r28.title)("id", item_r28.id)("tabindex", item_r28.tabindex ? item_r28.tabindex : "0");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", item_r28.icon);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(item_r28.label);
} }
function MegaMenu_ng_template_2_li_1_div_4_ng_template_2_ng_template_1_ng_template_3_li_1_a_2_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 16);
} if (rf & 2) {
    const item_r28 = ɵngcc0.ɵɵnextContext(3).$implicit;
    ɵngcc0.ɵɵproperty("ngClass", item_r28.icon);
} }
function MegaMenu_ng_template_2_li_1_div_4_ng_template_2_ng_template_1_ng_template_3_li_1_a_2_Template(rf, ctx) { if (rf & 1) {
    const _r43 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 30);
    ɵngcc0.ɵɵlistener("click", function MegaMenu_ng_template_2_li_1_div_4_ng_template_2_ng_template_1_ng_template_3_li_1_a_2_Template_a_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r43); const item_r28 = ɵngcc0.ɵɵnextContext(2).$implicit; const ctx_r42 = ɵngcc0.ɵɵnextContext(6); return ctx_r42.itemClick($event, item_r28); });
    ɵngcc0.ɵɵtemplate(1, MegaMenu_ng_template_2_li_1_div_4_ng_template_2_ng_template_1_ng_template_3_li_1_a_2_span_1_Template, 1, 1, "span", 13);
    ɵngcc0.ɵɵelementStart(2, "span", 14);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r28 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵproperty("routerLink", item_r28.routerLink)("queryParams", item_r28.queryParams)("routerLinkActive", "ui-menuitem-link-active")("routerLinkActiveOptions", item_r28.routerLinkActiveOptions || ɵngcc0.ɵɵpureFunction0(17, _c3))("ngClass", ɵngcc0.ɵɵpureFunction1(18, _c4, item_r28.disabled))("fragment", item_r28.fragment)("queryParamsHandling", item_r28.queryParamsHandling)("preserveFragment", item_r28.preserveFragment)("skipLocationChange", item_r28.skipLocationChange)("replaceUrl", item_r28.replaceUrl)("state", item_r28.state);
    ɵngcc0.ɵɵattribute("tabindex", item_r28.tabindex ? item_r28.tabindex : "0")("target", item_r28.target)("title", item_r28.title)("id", item_r28.id);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", item_r28.icon);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(item_r28.label);
} }
function MegaMenu_ng_template_2_li_1_div_4_ng_template_2_ng_template_1_ng_template_3_li_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 26);
    ɵngcc0.ɵɵtemplate(1, MegaMenu_ng_template_2_li_1_div_4_ng_template_2_ng_template_1_ng_template_3_li_1_a_1_Template, 4, 10, "a", 27);
    ɵngcc0.ɵɵtemplate(2, MegaMenu_ng_template_2_li_1_div_4_ng_template_2_ng_template_1_ng_template_3_li_1_a_2_Template, 4, 20, "a", 28);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r28 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(3, _c0, item_r28.visible === false));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !item_r28.routerLink);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", item_r28.routerLink);
} }
function MegaMenu_ng_template_2_li_1_div_4_ng_template_2_ng_template_1_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, MegaMenu_ng_template_2_li_1_div_4_ng_template_2_ng_template_1_ng_template_3_li_0_Template, 1, 3, "li", 23);
    ɵngcc0.ɵɵtemplate(1, MegaMenu_ng_template_2_li_1_div_4_ng_template_2_ng_template_1_ng_template_3_li_1_Template, 3, 5, "li", 24);
} if (rf & 2) {
    const item_r28 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngIf", item_r28.separator);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !item_r28.separator);
} }
function MegaMenu_ng_template_2_li_1_div_4_ng_template_2_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ul", 21);
    ɵngcc0.ɵɵelementStart(1, "li", 22);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, MegaMenu_ng_template_2_li_1_div_4_ng_template_2_ng_template_1_ng_template_3_Template, 2, 2, "ng-template", 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const submenu_r26 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(submenu_r26.label);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", submenu_r26.items);
} }
function MegaMenu_ng_template_2_li_1_div_4_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, MegaMenu_ng_template_2_li_1_div_4_ng_template_2_ng_template_1_Template, 4, 2, "ng-template", 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const column_r24 = ctx.$implicit;
    const category_r2 = ɵngcc0.ɵɵnextContext(3).$implicit;
    const ctx_r23 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMap(ctx_r23.getColumnClass(category_r2));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", column_r24);
} }
function MegaMenu_ng_template_2_li_1_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 19);
    ɵngcc0.ɵɵelementStart(1, "div", 20);
    ɵngcc0.ɵɵtemplate(2, MegaMenu_ng_template_2_li_1_div_4_ng_template_2_Template, 2, 3, "ng-template", 2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const category_r2 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", category_r2.items);
} }
const _c5 = function (a1, a2) { return { "ui-menuitem ui-corner-all": true, "ui-menuitem-active": a1, "ui-helper-hidden": a2 }; };
function MegaMenu_ng_template_2_li_1_Template(rf, ctx) { if (rf & 1) {
    const _r50 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 7, 8);
    ɵngcc0.ɵɵlistener("mouseenter", function MegaMenu_ng_template_2_li_1_Template_li_mouseenter_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r50); const _r6 = ɵngcc0.ɵɵreference(1); const category_r2 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r49 = ɵngcc0.ɵɵnextContext(); return ctx_r49.onItemMouseEnter($event, _r6, category_r2); })("mouseleave", function MegaMenu_ng_template_2_li_1_Template_li_mouseleave_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r50); const _r6 = ɵngcc0.ɵɵreference(1); const ctx_r52 = ɵngcc0.ɵɵnextContext(2); return ctx_r52.onItemMouseLeave($event, _r6); });
    ɵngcc0.ɵɵtemplate(2, MegaMenu_ng_template_2_li_1_a_2_Template, 5, 14, "a", 9);
    ɵngcc0.ɵɵtemplate(3, MegaMenu_ng_template_2_li_1_a_3_Template, 4, 23, "a", 10);
    ɵngcc0.ɵɵtemplate(4, MegaMenu_ng_template_2_li_1_div_4_Template, 3, 1, "div", 11);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const _r6 = ɵngcc0.ɵɵreference(1);
    const category_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(4, _c5, _r6 == ctx_r4.activeItem, category_r2.visible === false));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !category_r2.routerLink);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", category_r2.routerLink);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", category_r2.items);
} }
function MegaMenu_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, MegaMenu_ng_template_2_li_0_Template, 1, 3, "li", 4);
    ɵngcc0.ɵɵtemplate(1, MegaMenu_ng_template_2_li_1_Template, 5, 7, "li", 5);
} if (rf & 2) {
    const category_r2 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngIf", category_r2.separator);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !category_r2.separator);
} }
function MegaMenu_li_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 31);
    ɵngcc0.ɵɵprojection(1);
    ɵngcc0.ɵɵelementEnd();
} }
const _c6 = function (a1, a2) { return { "ui-megamenu ui-widget ui-widget-content ui-corner-all": true, "ui-megamenu-horizontal": a1, "ui-megamenu-vertical": a2 }; };
const _c7 = ["*"];
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let MegaMenu = class MegaMenu {
    constructor(el, renderer) {
        this.el = el;
        this.renderer = renderer;
        this.orientation = 'horizontal';
        this.autoZIndex = true;
        this.baseZIndex = 0;
    }
    onItemMouseEnter(event, item, menuitem) {
        if (menuitem.disabled) {
            return;
        }
        if (this.hideTimeout) {
            clearTimeout(this.hideTimeout);
            this.hideTimeout = null;
        }
        this.activeItem = item;
        if (menuitem.items) {
            let submenu = item.children[0].nextElementSibling;
            if (submenu) {
                if (this.autoZIndex) {
                    submenu.style.zIndex = String(this.baseZIndex + (++DomHandler.zindex));
                }
                if (this.orientation === 'horizontal') {
                    submenu.style.top = DomHandler.getOuterHeight(item.children[0]) + 'px';
                    submenu.style.left = '0px';
                }
                else if (this.orientation === 'vertical') {
                    submenu.style.top = '0px';
                    submenu.style.left = DomHandler.getOuterWidth(item.children[0]) + 'px';
                }
            }
        }
    }
    onItemMouseLeave(event, link) {
        this.hideTimeout = setTimeout(() => {
            this.activeItem = null;
        }, 1000);
    }
    itemClick(event, item) {
        if (item.disabled) {
            event.preventDefault();
            return;
        }
        if (!item.url) {
            event.preventDefault();
        }
        if (item.command) {
            item.command({
                originalEvent: event,
                item: item
            });
        }
        this.activeItem = null;
    }
    getColumnClass(menuitem) {
        let length = menuitem.items ? menuitem.items.length : 0;
        let columnClass;
        switch (length) {
            case 2:
                columnClass = 'ui-megamenu-col-6';
                break;
            case 3:
                columnClass = 'ui-megamenu-col-4';
                break;
            case 4:
                columnClass = 'ui-megamenu-col-3';
                break;
            case 6:
                columnClass = 'ui-megamenu-col-2';
                break;
            default:
                columnClass = 'ui-megamenu-col-12';
                break;
        }
        return columnClass;
    }
};
MegaMenu.ɵfac = function MegaMenu_Factory(t) { return new (t || MegaMenu)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
MegaMenu.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MegaMenu, selectors: [["p-megaMenu"]], inputs: { orientation: "orientation", autoZIndex: "autoZIndex", baseZIndex: "baseZIndex", model: "model", style: "style", styleClass: "styleClass" }, ngContentSelectors: _c7, decls: 4, vars: 9, consts: [[3, "ngStyle", "ngClass"], ["role", "menubar", 1, "ui-megamenu-root-list"], ["ngFor", "", 3, "ngForOf"], ["class", "ui-menuitem ui-menuitem-custom ui-corner-all", 4, "ngIf"], ["class", "ui-menu-separator ui-widget-content", 3, "ngClass", 4, "ngIf"], [3, "ngClass", "mouseenter", "mouseleave", 4, "ngIf"], [1, "ui-menu-separator", "ui-widget-content", 3, "ngClass"], [3, "ngClass", "mouseenter", "mouseleave"], ["item", ""], [3, "href", "ngClass", "ngStyle", "class", "click", 4, "ngIf"], [3, "routerLink", "queryParams", "routerLinkActive", "routerLinkActiveOptions", "ngClass", "ngStyle", "class", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "click", 4, "ngIf"], ["class", "ui-megamenu-panel ui-widget-content ui-corner-all ui-shadow", 4, "ngIf"], [3, "href", "ngClass", "ngStyle", "click"], ["class", "ui-menuitem-icon", 3, "ngClass", 4, "ngIf"], [1, "ui-menuitem-text"], ["class", "ui-submenu-icon pi pi-fw", 3, "ngClass", 4, "ngIf"], [1, "ui-menuitem-icon", 3, "ngClass"], [1, "ui-submenu-icon", "pi", "pi-fw", 3, "ngClass"], [3, "routerLink", "queryParams", "routerLinkActive", "routerLinkActiveOptions", "ngClass", "ngStyle", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "click"], [1, "ui-megamenu-panel", "ui-widget-content", "ui-corner-all", "ui-shadow"], [1, "ui-megamenu-grid"], ["role", "menu", 1, "ui-megamenu-submenu"], [1, "ui-widget-header", "ui-megamenu-submenu-header", "ui-corner-all"], ["class", "ui-menu-separator ui-widget-content", "role", "separator", 3, "ngClass", 4, "ngIf"], ["class", "ui-menuitem ui-corner-all", "role", "none", 3, "ngClass", 4, "ngIf"], ["role", "separator", 1, "ui-menu-separator", "ui-widget-content", 3, "ngClass"], ["role", "none", 1, "ui-menuitem", "ui-corner-all", 3, "ngClass"], ["role", "menuitem", "class", "ui-menuitem-link ui-corner-all", 3, "href", "ngClass", "click", 4, "ngIf"], ["role", "menuitem", "class", "ui-menuitem-link ui-corner-all", 3, "routerLink", "queryParams", "routerLinkActive", "routerLinkActiveOptions", "ngClass", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "click", 4, "ngIf"], ["role", "menuitem", 1, "ui-menuitem-link", "ui-corner-all", 3, "href", "ngClass", "click"], ["role", "menuitem", 1, "ui-menuitem-link", "ui-corner-all", 3, "routerLink", "queryParams", "routerLinkActive", "routerLinkActiveOptions", "ngClass", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "click"], [1, "ui-menuitem", "ui-menuitem-custom", "ui-corner-all"]], template: function MegaMenu_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "ul", 1);
        ɵngcc0.ɵɵtemplate(2, MegaMenu_ng_template_2_Template, 2, 2, "ng-template", 2);
        ɵngcc0.ɵɵtemplate(3, MegaMenu_li_3_Template, 2, 0, "li", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.styleClass);
        ɵngcc0.ɵɵproperty("ngStyle", ctx.style)("ngClass", ɵngcc0.ɵɵpureFunction2(6, _c6, ctx.orientation == "horizontal", ctx.orientation == "vertical"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.model);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.orientation === "horizontal");
    } }, directives: [ɵngcc1.NgStyle, ɵngcc1.NgClass, ɵngcc1.NgForOf, ɵngcc1.NgIf, ɵngcc2.RouterLinkWithHref, ɵngcc2.RouterLinkActive], encapsulation: 2 });
MegaMenu.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 }
];
__decorate([
    Input()
], MegaMenu.prototype, "model", void 0);
__decorate([
    Input()
], MegaMenu.prototype, "style", void 0);
__decorate([
    Input()
], MegaMenu.prototype, "styleClass", void 0);
__decorate([
    Input()
], MegaMenu.prototype, "orientation", void 0);
__decorate([
    Input()
], MegaMenu.prototype, "autoZIndex", void 0);
__decorate([
    Input()
], MegaMenu.prototype, "baseZIndex", void 0);
let MegaMenuModule = class MegaMenuModule {
};
MegaMenuModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: MegaMenuModule });
MegaMenuModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function MegaMenuModule_Factory(t) { return new (t || MegaMenuModule)(); }, imports: [[CommonModule, RouterModule],
        RouterModule] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MegaMenu, [{
        type: Component,
        args: [{
                selector: 'p-megaMenu',
                template: `
        <div [class]="styleClass" [ngStyle]="style"
            [ngClass]="{'ui-megamenu ui-widget ui-widget-content ui-corner-all':true,'ui-megamenu-horizontal': orientation == 'horizontal','ui-megamenu-vertical': orientation == 'vertical'}">
            <ul class="ui-megamenu-root-list" role="menubar">
                <ng-template ngFor let-category [ngForOf]="model">
                    <li *ngIf="category.separator" class="ui-menu-separator ui-widget-content" [ngClass]="{'ui-helper-hidden': category.visible === false}">
                    <li *ngIf="!category.separator" #item [ngClass]="{'ui-menuitem ui-corner-all':true,'ui-menuitem-active':item==activeItem, 'ui-helper-hidden': category.visible === false}"
                        (mouseenter)="onItemMouseEnter($event, item, category)" (mouseleave)="onItemMouseLeave($event, item)">
   
                        <a *ngIf="!category.routerLink" [href]="category.url||'#'" [attr.target]="category.target" [attr.title]="category.title" [attr.id]="category.id" (click)="itemClick($event, category)" [attr.tabindex]="category.tabindex ? category.tabindex : '0'"
                            [ngClass]="{'ui-menuitem-link ui-corner-all':true,'ui-state-disabled':category.disabled}" [ngStyle]="category.style" [class]="category.styleClass">
                            <span class="ui-menuitem-icon" *ngIf="category.icon" [ngClass]="category.icon"></span>
                            <span class="ui-menuitem-text">{{category.label}}</span>
                            <span *ngIf="category.items" class="ui-submenu-icon pi pi-fw" [ngClass]="{'pi-caret-down':orientation=='horizontal','pi-caret-right':orientation=='vertical'}"></span>
                        </a>
                        <a *ngIf="category.routerLink" [routerLink]="category.routerLink" [queryParams]="category.queryParams" [routerLinkActive]="'ui-menuitem-link-active'" [routerLinkActiveOptions]="category.routerLinkActiveOptions||{exact:false}" [attr.tabindex]="category.tabindex ? category.tabindex : '0'" 
                            [attr.target]="category.target" [attr.title]="category.title" [attr.id]="category.id"
                            (click)="itemClick($event, category)" [ngClass]="{'ui-menuitem-link ui-corner-all':true,'ui-state-disabled':category.disabled}" [ngStyle]="category.style" [class]="category.styleClass"
                            [fragment]="category.fragment" [queryParamsHandling]="category.queryParamsHandling" [preserveFragment]="category.preserveFragment" [skipLocationChange]="category.skipLocationChange" [replaceUrl]="category.replaceUrl" [state]="category.state">
                            <span class="ui-menuitem-icon" *ngIf="category.icon" [ngClass]="category.icon"></span>
                            <span class="ui-menuitem-text">{{category.label}}</span>
                        </a>

                        <div class="ui-megamenu-panel ui-widget-content ui-corner-all ui-shadow" *ngIf="category.items">
                            <div class="ui-megamenu-grid">
                                <ng-template ngFor let-column [ngForOf]="category.items">
                                    <div [class]="getColumnClass(category)">
                                        <ng-template ngFor let-submenu [ngForOf]="column">
                                            <ul class="ui-megamenu-submenu" role="menu">
                                                <li class="ui-widget-header ui-megamenu-submenu-header ui-corner-all">{{submenu.label}}</li>
                                                <ng-template ngFor let-item [ngForOf]="submenu.items">
                                                    <li *ngIf="item.separator" class="ui-menu-separator ui-widget-content" [ngClass]="{'ui-helper-hidden': item.visible === false}" role="separator">
                                                    <li *ngIf="!item.separator" class="ui-menuitem ui-corner-all" [ngClass]="{'ui-helper-hidden': item.visible === false}" role="none">
                                                        <a *ngIf="!item.routerLink" role="menuitem" [href]="item.url||'#'" class="ui-menuitem-link ui-corner-all" [attr.target]="item.target" [attr.title]="item.title" [attr.id]="item.id" [attr.tabindex]="item.tabindex ? item.tabindex : '0'"
                                                            [ngClass]="{'ui-state-disabled':item.disabled}" (click)="itemClick($event, item)">
                                                            <span class="ui-menuitem-icon" *ngIf="item.icon" [ngClass]="item.icon"></span>
                                                            <span class="ui-menuitem-text">{{item.label}}</span>
                                                        </a>
                                                        <a *ngIf="item.routerLink" role="menuitem" [routerLink]="item.routerLink" [queryParams]="item.queryParams" [routerLinkActive]="'ui-menuitem-link-active'" [attr.tabindex]="item.tabindex ? item.tabindex : '0'"
                                                            [routerLinkActiveOptions]="item.routerLinkActiveOptions||{exact:false}" class="ui-menuitem-link ui-corner-all" 
                                                             [attr.target]="item.target" [attr.title]="item.title" [attr.id]="item.id"
                                                            [ngClass]="{'ui-state-disabled':item.disabled}" (click)="itemClick($event, item)"
                                                            [fragment]="item.fragment" [queryParamsHandling]="item.queryParamsHandling" [preserveFragment]="item.preserveFragment" [skipLocationChange]="item.skipLocationChange" [replaceUrl]="item.replaceUrl" [state]="item.state">
                                                            <span class="ui-menuitem-icon" *ngIf="item.icon" [ngClass]="item.icon"></span>
                                                            <span class="ui-menuitem-text">{{item.label}}</span>
                                                        </a>
                                                    </li>
                                                </ng-template>
                                            </ul>
                                        </ng-template>
                                    </div>
                                </ng-template>
                            </div>
                        </div>
                    </li>
                </ng-template>
                <li class="ui-menuitem ui-menuitem-custom ui-corner-all" *ngIf="orientation === 'horizontal'">
                    <ng-content></ng-content>
                </li>
            </ul>
        </div>
    `,
                changeDetection: ChangeDetectionStrategy.Default
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, { orientation: [{
            type: Input
        }], autoZIndex: [{
            type: Input
        }], baseZIndex: [{
            type: Input
        }], model: [{
            type: Input
        }], style: [{
            type: Input
        }], styleClass: [{
            type: Input
        }] }); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MegaMenuModule, { declarations: function () { return [MegaMenu]; }, imports: function () { return [CommonModule, RouterModule]; }, exports: function () { return [MegaMenu,
        RouterModule]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MegaMenuModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, RouterModule],
                exports: [MegaMenu, RouterModule],
                declarations: [MegaMenu]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { MegaMenu, MegaMenuModule };

//# sourceMappingURL=primeng-megamenu.js.map